// While an admin is acting as a dentist, the dentist's email is kept here and sent to the
// API as the X-Act-As-Dentist header. sessionStorage keeps it to the current tab.
const ACTING_AS_KEY = "actingAsDentist";
export const ACT_AS_HEADER = "X-Act-As-Dentist";

export const getActingAs = (): string | null => sessionStorage.getItem(ACTING_AS_KEY);

export const setActingAs = (email: string) => sessionStorage.setItem(ACTING_AS_KEY, email);

export const clearActingAs = () => sessionStorage.removeItem(ACTING_AS_KEY);

// Headers to spread into requests that call axios directly and so skip the api.tsx interceptor
export const actingAsHeaders = (): Record<string, string> => {
  const email = getActingAs();
  return email ? { [ACT_AS_HEADER]: email } : {};
};
